document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    if (document.body.hasAttribute("data-header-padding")) {
      const banner = document.querySelector(".new_slideshow_split");

      banner.classList.add("ab-header");
    }
  });

  observer.observe(document.body, {
    attributes: true,
    childList: false,
    subtree: false,
  });
});
